import ResellerShell from './ResellerShell'
import { MarginInspectorBody } from '../admin/MarginInspector'

/**
 * Reseller-portal Margin Inspector — the same price-breakdown tool as the
 * super-admin one, but every query is scoped to the caller's own account
 * (bookings + packages). Access is gated per-account by MarginInspectorEnabled,
 * which only InteGolf super-admin can turn on; the nav item + this route are
 * hidden otherwise, and the backend enforces the flag regardless.
 */
export default function MarginInspector() {
  return (
    <ResellerShell title="Margin Inspector">
      <MarginInspectorBody base="/portal/reseller/margin-inspector" />
    </ResellerShell>
  )
}
